import { observable } from "@legendapp/state";

import { activeOrganization$ } from "./organizations";

/**
 * Truthy when an active organization is selected AND that org has finished
 * onboarding. Used as the `waitFor` for app-data CRUD stores that should
 * only sync once the user has cleared the onboarding wizard.
 *
 * Datasource / catalog / connections CRUD stores intentionally do NOT use
 * this as their `waitFor` — they can be called during the pre-payment
 * datasource and catalog steps of the wizard via `orgReady$`.
 */
export const appDataReady$ = observable(() => {
  const org = activeOrganization$.get();
  return !!org?.id && org.onboarding === "done";
});

/**
 * Looser `waitFor` for CRUD stores whose endpoints use plain
 * `organizationProcedure` (datasources, catalogs, connections). Truthy
 * whenever an active org is selected — the underlying tRPC procedures
 * don't require a subscription, so these stores can sync during the
 * pre-payment datasource / catalog / sample steps of the wizard.
 */
export const orgReady$ = observable(() => {
  const org = activeOrganization$.get();
  return !!org?.id;
});
